import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
	selector: 'app-logo-upload',
	templateUrl: './logo-upload.component.html',
	styleUrls: ['./logo-upload.component.css'],
	imports: [CommonModule, FormsModule],
	standalone: true,
})
export class LogoUploadComponent {
	@Input() logoUrl: string;
	@Output() fileSelected = new EventEmitter<File | null>();

	currentFile: File | null = null;
	previewUrl: string | null = null;
	errorMessage: string | null = null;
	isDragOver = false;
	showOverlay = false;

	onFileSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		if (input.files && input.files.length > 0) {
			this.handleFile(input.files[0]);
		}
	}

	onDrop(event: DragEvent): void {
		event.preventDefault();
		this.isDragOver = false;
		if (event.dataTransfer?.files.length) {
			this.handleFile(event.dataTransfer.files[0]);
		}
	}

	onDragOver(event: DragEvent): void {
		event.preventDefault();
		this.isDragOver = true;
	}

	onDragLeave(event: DragEvent): void {
		event.preventDefault();
		this.isDragOver = false;
	}

	handleFile(file: File): void {
		this.errorMessage = null;
		this.currentFile = file;
		this.fileSelected.emit(file);

		const reader = new FileReader();
		reader.onload = () => {
			this.previewUrl = reader.result as string;
		};
		reader.readAsDataURL(file);
	}

	removeImage(): void {
		this.currentFile = null;
		this.previewUrl = null;
		this.logoUrl = null;
		this.errorMessage = null;
		this.fileSelected.emit(null);
	}
}
